// extracted by mini-css-extract-plugin
module.exports = {"download":"style_download__2rV5Z","download__btn":"style_download__btn__1q7Ju"};